<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="$refs.header.query()"
      @openDetailDialog="openDetailDialog"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </page-main>
    <DemandDetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_production_order_fabric_detail_info') ||
          '订单面料需求详情'
      "
      :orderFabricCode="detailDialogOptions.code"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import DemandDetailDialog from '../detail/dialog.vue'
export default {
  mixins: [BaseTable],
  components: {
    PageMain,
    PageHeader,
    DemandDetailDialog,
  },
  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {},
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderDemandFabricListApi({
          orderCode: this.orderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderFabricCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderFabricCode,
      }
    },
  },
}
</script>
